<template>
    <div v-show="visible">
        <label>
            {{ t(displayName) }}
        </label>
        <div class="range-filter">
            <input type="number" :step="step" :min="minValue" v-model="value[0]" @change="onInput" class="controls form-control" :class="errorClassMin">
            <input type="number" :step="step" :max="maxValue" v-model="value[1]" @change="onInput" class="controls form-control" :class="errorClassMax">
        </div>
    </div>
</template>

<script>

import ValueChecker from "@/services/ValueChecker";

export default {
    components: {},
    props: {
        config: {
            type: Object,
            default: () => {
                return {
                    name: null,
                    group: false,
                    value: [],
                    display: true,
                    position: 0,
                    step: 5,
                    isMultiple: null,
                    displayName: null
                };
            }
        },
        eventBus: {
            Type: Object,
        },
        queryParams: {
            Type: Object
        },
        routeParams: {
            Type: Object
        },
        onChange: {
            Type: Function,
        },
        onDefaultValueSet: {
            Type: Function,
        },
    },
    data() {
        return {
            interval: null,
            displayName: null,
            visible: true,
            value: [],
            minValue: null,
            maxValue: null,
            name: null,
            step: 5,
            errorClassMin: null,
            errorClassMax: null,
        };
    },
    mounted() {
        this.init();
        this.$parent.$on(`${this.name}-set-value`, (filterState) => {
            this.setValue(filterState);
        });
        this.setDefaultValue(this.queryParams[this.name] || this.config.value);
    },
    computed: {
    },
    methods: {
        onInput() {
            clearInterval(this.interval);

            if (!this.validate()) {
              return;
            }

            this.interval = setTimeout(() => {
              this.onChange(this.name, this.value);
            }, 1000);
        },
        validate() {
            this.clearError();

            if (this.value.length === 0) {
                return true;
            }

            let value0 = Number.parseFloat(this.value[0]);
            let value1 = Number.parseFloat(this.value[1]);

            if (!ValueChecker.isUndefinedOrNull(this.minValue) && value0 < this.minValue) {
                this.setErrorValue0();

                return false;
            }

            if (Number.isNaN(value1)) {
                return true;
            }

            if (!ValueChecker.isUndefinedOrNull(this.maxValue) && value1 > this.maxValue) {
                this.setErrorValue1();

                return false;
            }

            if (value1 < value0) {
                this.setErrorValue1();

                return false;
            }

            return true;
        },
        init() {
            this.displayName = this.config.displayName;
            this.visible = this.config.visible;

            if (!ValueChecker.isUndefinedOrNull(this.config.step)) {
              this.step = this.config.step;
            }

            this.minValue = this.config.minValue;
            this.maxValue = this.config.maxValue;
            this.name = this.config.name;
        },
        setDefaultValue(value) {
            this.setValue(value);
            this.onDefaultValueSet(this.name, this.value);
        },
        setValue(value) {
            this.value = value;
        },
        setErrorValue0() {
            this.errorClassMin = 'mark-as-error';
        },
        setErrorValue1() {
            this.errorClassMax = 'mark-as-error';
        },
        clearError() {
            this.errorClassMin = null;
            this.errorClassMax = null;
        }
    }
}

</script>

<style lang="sass" scoped>
.mark-as-error {
    border: 1.5px solid red;
}
.range-filter {
    display: flex;
    gap: 4px;
}
.range-filter input {
    flex: 1;
    min-width: 0;
    height: 42px;
    border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// RangeComponent.vue?50f71f83